import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';

const QUICK_ACTIONS = [
  {
    id: 'scan',
    label: 'AR Scan',
    description: 'Scan a product to check budget impact',
    icon: 'ScanLine',
    path: '/ar-scanner-interface',
    accent: true,
  },
  {
    id: 'budget',
    label: 'Manage Budget',
    description: 'Adjust spending limits and categories',
    icon: 'PieChart',
    path: '/home-dashboard',
    accent: false,
  },
  {
    id: 'setup',
    label: 'Financial Setup',
    description: 'Configure your financial profile',
    icon: 'Settings2',
    path: '/onboarding-dashboard',
    accent: false,
  },
];

export default function QuickActionPanel({ budgetData = null, className = '' }) {
  const navigate = useNavigate();

  const handleAction = (path) => {
    navigate(path);
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-h5 text-[#F8FAFC]">Quick Actions</h3>
        {budgetData && (
          <span className="font-data text-xs text-[#94A3B8] bg-[rgba(6,182,212,0.08)] px-3 py-1 rounded-full border border-[rgba(6,182,212,0.15)]">
            Budget: <span className="text-accent">${budgetData?.remaining ?? '—'}</span> left
          </span>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {QUICK_ACTIONS?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleAction(action?.path)}
            aria-label={`${action?.label}: ${action?.description}`}
            className={`group relative flex flex-col items-start gap-3 p-5 rounded-lg border transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] text-left min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background active:scale-[0.97] ${
              action?.accent
                ? 'bg-gradient-to-br from-[rgba(6,182,212,0.15)] to-[rgba(6,182,212,0.05)] border-[rgba(6,182,212,0.3)] hover:border-[rgba(6,182,212,0.5)] hover:shadow-glow-md'
                : 'bg-card border-[rgba(6,182,212,0.1)] hover:border-[rgba(6,182,212,0.25)] hover:shadow-glow-sm'
            }`}
          >
            <div
              className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:scale-110 ${
                action?.accent
                  ? 'bg-accent text-[#0F172A]'
                  : 'bg-[rgba(6,182,212,0.1)] text-accent'
              }`}
            >
              <Icon
                name={action?.icon}
                size={20}
                color={action?.accent ? '#0F172A' : 'var(--color-accent)'}
                strokeWidth={2}
              />
            </div>
            <div className="flex-1 min-w-0">
              <p
                className={`font-heading font-semibold text-sm mb-0.5 ${
                  action?.accent ? 'text-accent' : 'text-[#F8FAFC]'
                }`}
              >
                {action?.label}
              </p>
              <p className="font-caption text-xs text-[#94A3B8] leading-snug line-clamp-2">
                {action?.description}
              </p>
            </div>
            <Icon
              name="ArrowRight"
              size={16}
              color="var(--color-muted-foreground)"
              className="absolute bottom-4 right-4 transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:translate-x-1 group-hover:text-accent"
            />
          </button>
        ))}
      </div>
    </div>
  );
}